module.exports = __webpack_public_path__ + "res/img/unstar.65a488a7.png";